import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=085fe753&scoped=true&"
import script from "./proxy.vue?vue&type=script&lang=js&"
export * from "./proxy.vue?vue&type=script&lang=js&"
import style0 from "./proxy.vue?vue&type=style&index=0&id=085fe753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085fe753",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085fe753')) {
      api.createRecord('085fe753', component.options)
    } else {
      api.reload('085fe753', component.options)
    }
    module.hot.accept("./proxy.vue?vue&type=template&id=085fe753&scoped=true&", function () {
      api.rerender('085fe753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/proxy.vue"
export default component.exports